// import useState from 'react';

function Header() {
  return (
    <div className="row">
      <h1 className="col-12 d-flex justify-content-center p-3">Joshua Schermann</h1>
    </div>
  );
}

export default Header;
